"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <footer id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577657/img/business_tantra_logo_gold.png" alt="Business Tantra" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Business Tantra is a premium brand and trademark acquisition advisory. We help entrepreneurs buy, sell, and monetize registered trademarks with legal clarity and fast execution.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex items-center justify-center size-9 rounded-full border border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <social.icon className="size-4" />
                </Link>)}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-tight">
              Quick Links
            </h3>
            <MenuProvider menu_id="40">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-tight">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Delhi – 110018, India</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Phone className="size-5 text-primary shrink-0" />
                <Link to="https://wa.me/918820000222" newTab className="hover:text-primary transition-colors duration-200">
                  +91-8820000222
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:support@business-tantra.com" className="hover:text-primary transition-colors duration-200">
                  support@business-tantra.com
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-tight">
              Legal Framework
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              All trademark transfers, acquisitions, and licensing agreements facilitated by Business Tantra are executed in strict compliance with the provisions of the Trade Marks Act, 1999. We ensure end-to-end legal coordination for secure and transparent transactions.
            </p>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-xs">
            &copy; {new Date().getFullYear()} Business Tantra. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-muted-foreground">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}